import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import M from 'materialize-css/dist/js/materialize';
import $ from 'jquery';
import ReceiptContainerFinish from './ReceiptContainerFinish'
import ReceiptContainer from './ReceiptContainer'
import { BackButton } from '../../../components/UI/ComponentsUI';
import { showMessageToastCustom } from '../../../utils/util';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';

const ReceiptContainerMain = (props) => {
    const [table, setTable] = useState(0);
    const [items, setItems] = useState([]);

    useEffect(() => {
        const el = $('.tabs');
        M.Tabs.init(el);
        M.Tabs.getInstance(el).select(getTabName(table));
        // eslint-disable-next-line
    }, []);

    const getTabName = (tabIndex) => {
        switch (tabIndex) {
            case 0:
                return 'receiptList';
            case 1:
                return 'other';
            default:
                return
        }
    }

    const onSelectedTab = () => {
        const el = $('.tabs');
        let index = M.Tabs.getInstance(el)?.index;
        if (table !== index) {
            setTable(index);
        }
    };

    const onSubmit = (container) => {
        props.getReceipts({ container: container }, r => {
            if (r.data?.length > 0) {
                setItems(r.data)
            } else {
                showMessageToastCustom('Não encontrado',
                    'Nenhum partnumber encontrado para esse código',
                    3000, 'mdi mdi-alert-circle-outline red-text');
            }
        });
    }

    return (
        <div className="">
            <BackButton {...props} />
            <div className="third-text-color">
                <div className="row" style={{ marginBottom: '-1px', marginTop: '10px' }}>
                    <ul className="tabs">
                        <li className="tab col s6">
                            <a className="active" href="#receiptList" onClick={onSelectedTab}>
                                <i className="material-icons prefix">list</i>
                            </a>
                        </li>
                        <li className="tab col s6">
                            <a className="" href="#other" onClick={onSelectedTab}>
                                <i className="material-icons prefix">check</i>
                            </a>
                        </li>
                    </ul>
                </div>
                <div>
                    <div id="receiptList" className="col s12">
                        {
                            table === 0 && <ReceiptContainer items={items} onCancel={() => setItems([])} onSubmit={onSubmit} />
                        }
                    </div>
                    <div id="other" className="col s12">
                        {
                            table === 1 && <ReceiptContainerFinish items={items} onCancel={() => setItems([])} />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = () => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getReceipts: (filter, callback) => {
            dispatch(PhysicalConfirmationService.getReceipts(filter, callback));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReceiptContainerMain));